import { render } from "./ClientLandingPage.vue?vue&type=template&id=05f411df&scoped=true"
import script from "./ClientLandingPage.vue?vue&type=script&lang=js"
export * from "./ClientLandingPage.vue?vue&type=script&lang=js"

import "./ClientLandingPage.vue?vue&type=style&index=0&id=05f411df&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05f411df"]])

export default __exports__